import { render, staticRenderFns } from "./UpdateSurveyFormSystem.vue?vue&type=template&id=33d8c097&scoped=true"
import script from "./UpdateSurveyFormSystem.vue?vue&type=script&lang=js"
export * from "./UpdateSurveyFormSystem.vue?vue&type=script&lang=js"
import style0 from "./UpdateSurveyFormSystem.vue?vue&type=style&index=0&id=33d8c097&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d8c097",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d8c097')) {
      api.createRecord('33d8c097', component.options)
    } else {
      api.reload('33d8c097', component.options)
    }
    module.hot.accept("./UpdateSurveyFormSystem.vue?vue&type=template&id=33d8c097&scoped=true", function () {
      api.rerender('33d8c097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SurveyForm/dialog/UpdateSurveyFormSystem.vue"
export default component.exports